var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('top-header',{attrs:{"title":"Utilisateurs"}}),_c('v-row',[_c('v-col',[_c('manage-users',{attrs:{"fill-height":"","searchable":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }